import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const statisticsComponentStyles = makeStyles((theme: Theme) =>
    createStyles({
        component: {
            backgroundColor: "white",
            marginTop: "50px",
            minWidth: "565px",
            minHeight: "138px",
            borderRadius: "0px",
            boxShadow: "0px 4px 10px rgba(110, 102, 102, 0.2);",
            paddingLeft: "37px",
            paddingRight: "26px",
            paddingTop: "10px",
            padding: "10px 26px 13px 37px",
            color: theme.colors.neutrals.neutral500,
        },
        componentWithoutButton: {
            paddingTop: "50px",
        },
        title: {
            marginRight: "35px",
            width: "160px",
            fontSize: "16px",
            lineHeight: "24px",
            marginTop: "-4px",
        },
        subTitle: {
            paddingTop: "5px",
            color: "#454B60",
        },
        buttonWrapper: {
            display: "flex",
            alignItems: "flex-end",
            marginLeft: 460,
            marginTop: 10,
            marginBottom: 15,
            borderRadius: "4px",
        },

        buttonContainer: {
            display: "flex",
            justifyContent: "end",
            marginBottom: "17px",
        },

        buttonCelsius: {
            display: "flex",
            alignItems: "flex-end",
            minHeight: "auto",
            height: 30,
            width: 35,
            minWidth: "auto",
            border: "1px solid #525252",
            borderRadius: "4px 0px 0px 4px",
            "&:hover": {
                backgroundColor: theme.colors.neutrals.neutral200,
            },
        },
        buttonFahrenheit: {
            display: "flex",
            alignItems: "flex-end",
            minHeight: "auto",
            height: 30,
            width: 35,
            minWidth: "auto",
            border: "1px solid #525252",
            borderRadius: "0px 4px 4px 0px",
            "&:hover": {
                backgroundColor: theme.colors.neutrals.neutral200,
            },
        },
        selectedButton: {
            border: "0px",
            backgroundColor: theme.colors.primary.blue500,
            color: "white",
            "&:hover": {
                backgroundColor: theme.colors.primary.blue500,
                color: "white",
            },
        },

        indicator: {
            height: "50px",
            flexGrow: 1,
            paddingRight: "35px",
        },
    })
);
